import Modal from '@cp/src/components/Modal/Modal';
import Button from '@navi/web-ui/lib/primitives/Button/Button';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import styles from './index.module.scss';
import { useDispatch } from 'react-redux';
import { getTelephonesV2, removeContact } from '../../actions/casesDetailsActions';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { IRemoveNumberModalProps } from './interface';

const RemoveNumberModal = (props: IRemoveNumberModalProps) => {
  const { isModalOpen, setIsModalOpen, callData } = props;
  const dispatch = useDispatch();
  const {
    loanId = '',
    customerId = '',
    caseBusinessVertical = '',
    caseReferenceId = ''
  } = useParams();

  const handleDeleteNumber = (number: string) => () => {
    removeContact(customerId, number, setIsModalOpen, successCallback);
  };
  const successCallback = useCallback(() => {
    dispatch(getTelephonesV2(loanId, customerId, caseReferenceId, caseBusinessVertical));
  }, []);

  return (
    <Modal
      iconButtonSize="small"
      headerClassName={styles.modalContainer}
      visible={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      header={`You are removing ${callData?.number}`}
    >
      <div className="flex flex-col gap-[24px]">
        <Typography variant="p2" color="var(--grayscale-2)">
          Are you sure you want to continue?
        </Typography>
        <div className="flex justify-start gap-[8px]">
          <Button
            size="medium"
            onClick={handleDeleteNumber(callData?.number)}
            className={styles.removeButton}
          >
            Remove
          </Button>
          <Button
            variant="primary"
            onClick={() => setIsModalOpen(false)}
            className={styles.cancelButton}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveNumberModal;
